import api from './base';

export const tutorsApi = {
  // Legacy tutors endpoints
  sendMessageLegacy: (tutorId, message, token) =>
    api.post(
      `/tutors/${tutorId}/messages`,
      { message },
      { headers: { Authorization: `Token ${token}` } }
    ),

  getConversation: (tutorId, token) =>
    api.get(`/tutors/${tutorId}/conversation`, {
      headers: { Authorization: `Token ${token}` },
    }),

  createTutor: (tutorData, token) =>
    api.post('/tutors/', tutorData, {
      headers: { Authorization: `Token ${token}` },
    }),

  getTutors: (token) =>
    api.get('/tutors/', {
      headers: { Authorization: `Token ${token}` },
    }),

  getTutor: (tutorId, token) =>
    api.get(`/tutors/${tutorId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  updateTutor: (tutorId, tutorData, token) =>
    api.put(`/tutors/${tutorId}`, tutorData, {
      headers: { Authorization: `Token ${token}` },
    }),

  deleteTutor: (tutorId, token) =>
    api.delete(`/tutors/${tutorId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  // AI Tutor specific endpoints
  getAITutors: (type, token) =>
    api.get(`/aitutor/ai-tutors/?access_type=${type}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  createAITutor: (tutorData, token) =>
    api.post('/aitutor/ai-tutors/', tutorData, {
      headers: { Authorization: `Token ${token}` },
    }),

  getAITutor: (tutorId, token) =>
    api.get(`/aitutor/ai-tutors/${tutorId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  updateAITutor: (tutorId, tutorData, token) =>
    api.put(`/aitutor/ai-tutors/${tutorId}/`, tutorData, {
      headers: { Authorization: `Token ${token}` },
    }),

  deleteAITutor: (tutorId, token) =>
    api.delete(`/aitutor/ai-tutors/${tutorId}/`, {
      headers: { Authorization: `Token ${token}` },
    }),

  createConversation: (title, tutorId, token) =>
    api.post('/aitutor/conversations/',
      {
        name: title,
        ai_tutor_id: tutorId
      },
      { headers: { Authorization: `Token ${token}` } }
    ),

  // Conversations
  getConversations: (token) =>
    api.get('/aitutor/conversations/', {
      headers: { Authorization: `Token ${token}` }
    }),

  getChatHistory: (conversationId, token) =>
    api.get(`/aitutor/conversations/${conversationId}/chat-history/`, {
      headers: { Authorization: `Token ${token}` }
    }),

  updateConversation: (conversationId, data, token) =>
    api.put(`/aitutor/conversations/${conversationId}/`, data, {
      headers: { Authorization: `Token ${token}` }
    }),

  archiveConversation: (conversationId, token) =>
    api.delete(`/aitutor/conversations/${conversationId}/`, {
      headers: { Authorization: `Token ${token}` }
    }),

  sendMessage: (tutorId, data, token) =>
    api.post(`/aitutor/${tutorId}/chat/`, data, {
      headers: { Authorization: `Token ${token}` }
    }),

  // Materials
  uploadMaterial: (tutorId, file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/aitutor/ai-tutors/${tutorId}/upload-material/`, formData, {
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Sandbox associations
  getSandboxes: (token) =>
    api.get('/aitutor/sandboxes/', {
      headers: { Authorization: `Token ${token}` }
    }),

  getSandboxInstances: (token) =>
    api.get('/aitutor/sandbox-instances/', {
      headers: { Authorization: `Token ${token}` }
    }),
};
